






















































































































import { MetadataField } from "@/model/data.model";
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import SearchCheckbox from "./SearchCheckbox.vue";
import SearchDateRange from "./SearchDateRange.vue";
// import SearchPagination from './SearchPagination.vue';
import SearchSelect from "./SearchSelect.vue";
import SearchText from "./SearchText.vue";

@Component({
  components: {
    SearchSelect,
    SearchCheckbox,
    SearchText,
    SearchDateRange
    // 		SearchPagination
  }
})
export default class SearchFilters extends Vue {
  @Prop({ default: false })
  isArticleFromSale: boolean;
  @Prop({})
  search: any;
  @Prop({})
  filters: MetadataField[];
  @Prop({})
  context: string;
  @Prop({})
  type: string;
  @Prop({})
  operations: any;
  @Prop({ default: false })
  emitAutocompleteResults: boolean;

  customers: any = [];
  wasDateChanged = false;

  codSelected: any = {
    selected: false,
    isNull: {
      selected: true
    }
  };

  groupBy(arr: any, prop: any) {
    return arr.reduce(function(groups: any, item: any) {
      const val = item[prop];
      groups[val] = groups[val] || [];
      groups[val].push(item);
      return groups;
    }, {});
  }

  get filterGroups() {
    return this.groupBy(
      this.filters.filter((el: any) => {
        return el.visible && el.field !== "claim.assigneeId";
      }),
      "group"
    );
  }

  get isInvoiceStoreIdField() {
    return function(field: any) {
      return (
        field.type === "BOOLEAN" &&
        (field.field === "customField.documentHead.storeId" ||
          field.field === "customField.storeId")
      );
    };
  }

  getClassFromType(fieldObj: any) {
    if (
      this.context == "invoice-documents-search" &&
      fieldObj.field == "documentHead.customerId"
    ) {
      return "col-md-12 col-lg-8 col-xl-6";
    }

    // override custom sizing for columns based on types...
    if (fieldObj.size != null) {
      const map: any = {};
      map["col-xl-" + String(fieldObj.size)] = true;
      return map;
    }

    if (
      this.context == "invoice-documents-search" &&
      fieldObj.field == "documentHead.saleDate"
    ) {
      return "col-lg-7 col-xl-6";
    }

    if (
      this.context == "invoice-documents-search" &&
      fieldObj.field == "documentHead.salesTypeId"
    ) {
      return "col-md-6 col-xl-6";
    }
    if (
      this.context == "article-quote" &&
      fieldObj.field == "documentHead.salesTypeId"
    ) {
      return "col-md-6 col-xl-6";
    }

    if (
      this.context == "invoice-documents-search" &&
      fieldObj.field == "customField.documentHead.storeId"
    ) {
      return "col-md-12 col-lg-4 col-xl-6";
    }

    // else use type information to determine the right size for the element
    return {
      "col-sm-6 col-md-5 col-lg-4 col-xl-3": [
        "BOOLEAN",
        "PRESENCE",
        "NOT_PRESENCE"
      ].includes(fieldObj.type),
      "col-md-6 col-xl-3": ![
        "DATE",
        "LOCALDATETIME",
        "BOOLEAN",
        "PRESENCE",
        "NOT_PRESENCE"
      ].includes(fieldObj.type),
      "col-lg-5 col-xl-4": ["DATE", "LOCALDATETIME"].includes(fieldObj.type)
    };
  }

  checkNullState(key: string) {
    if (this.codSelected.isNull[key] === true) {
      this.codSelected[key] = true;
      this.codSelected.isNull[key] = false;
    } else if (
      this.codSelected.isNull[key] === false &&
      this.codSelected[key] === true
    ) {
      this.codSelected[key] = false;
    } else if (
      this.codSelected.isNull[key] === false &&
      this.codSelected[key] === false
    ) {
      this.codSelected[key] = true;
      this.codSelected.isNull[key] = true;
    }
    this.handleChangeCodCheck(key);
  }

  handleChangeCodCheck(key: string) {
    if (this.codSelected.isNull[key] === true) {
      delete this.search["extraServices.mbeBusinessId_and"];
    } else {
      const codOperation = this.codSelected[key] === true ? "=" : "!=";
      this.search["extraServices.mbeBusinessId_and"] = [
        {
          field: "extraServices.mbeBusinessId",
          type: "INTEGER",
          operation: codOperation,
          values: [2]
        }
      ];
    }
  }

  getCustomLabel(filter: any) {
    if (
      this.context === "invoice-cumulative" &&
      filter.field === "documentHead.customerBusinessName"
    ) {
      return this.$i18n.t("invoice_holder");
    }
    if (
      (this.context === "invoice-cumulative" ||
        this.context === "invoice-massive-cumulative") &&
      filter.field === "documentHead.shipmentInfo.refDescription"
    ) {
      return this.$i18n.t("refDescription");
    }
    if (
      this.context === "shipments-search" &&
      filter.field === "customsDutiesToCustomer"
    ) {
      return this.$i18n.t("customsDutiesToCustomer_short");
    }
    if (
      this.context === "shipments-send-data" &&
      filter.field === "deliveryDocument"
    ) {
      return this.$i18n.t("filter_delivery_document");
    }
    return null;
  }

  handleAutocompleteResults(payload: any) {
    this.$emit("handleAutocompleteResults", payload);
  }
  clients: any = [];
  getRemoteOptions(payload: any) {
    this.clients = payload;
  }

  startTextLength(value: any) {
    if (value && value.includes("*") && value.length < 5) {
      return true;
    }

    return false;
  }

  onDateChanged() {
    this.$emit("dateChanged");
  }
}
